// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__Xmwd3","title":"Menu_title__qnqpa","entry":"Menu_entry__t5y_W","icon":"Menu_icon__0sSw3"};